const questionnaire = {
  name: "User Onboarding",
  version: "1",
  startFrom: "NAME",
  questions: {
    NAME: {
      question: "What is your name?",
      responseType: "object",
      next: "TREATING-DOC",
    },
    "TREATING-DOC": {
      question: "Are you currently taking treatment from...",
      choices: [
        {
          value: "DR000001",
          text: "Dr. S.M. Akerkar",
          next: "TREATING-LOC",
        },
        {
          value: "NEW_PATIENT",
          text: "No. I'm a new patient.",
          next: "DOB",
        },
      ],
      responseType: "singleChoice",
    },

    KNOWS_THE_DOCTORS: {
      question: "Do you know which doctor you want to register for?",
      choices: [
        {
          value: "yes",
          text: "Yes",
          next: "CHOOSE_DOC",
        },
        {
          value: "no",
          text: "No",
          next: "PREF-TREATING-LOC",
        },
      ],
      responseType: "singleChoice",
    },

    "CHOOSE-DOC": {
      question: "Choose a Doctor",
      choices: [
        {
          value: "DR000001",
          text: "Dr. S.M. Akerkar",
          next: "EXISTING-PATIENT",
        },
      ],
      responseType: "singleChoice",
    },
    "EXISTING-PATIENT": {
      question: "Are you currently taking treatment from <Doctor Name>?",
      choices: [
        {
          value: "yes",
          text: "Yes",
          next: "TREATING-LOC",
        },
        {
          value: "no",
          text: "No",
          next: "PREF-TREATING-LOC",
        },
      ],
      responseType: "singleChoice",
    },
    "TREATING-LOC": {
      question: "Where are you taking the treatment from?",
      choices: [
        {
          value: "CC000001",
          text: "Mumbai Arthritis Clinic (Bhandup)",
          disabled: false,
          hasOldPatients: true,
          next: "PID",
        },
        {
          value: "CC000002",
          text: "Ajit Scanning Center (Kalyan)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000000",
          text: "Online",
          disabled: false,
          hasOldPatients: false,
          next: "PREF-TREATING-LOC",
        },
        {
          value: "CC000003",
          text: "ICON Hospital (Dombivli)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000004",
          text: "Shreyas Health Care Clinic (Badlapur)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000005",
          text: "Suchak Polyclinic & Hospital(Malad)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },

        {
          value: "CC000006",
          text: "Bliss Clinic (Thane)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000009",
          text: "Spandan Clinic (Airoli)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000010",
          text: "AIMS (Thane)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },

        {
          value: "CC000011",
          text: "Sigma Hospital (Mulund West)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000012",
          text: "Good Health Clinics (Bhandup West)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000013",
          text: "Good Health Clinics (Bhandup East)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000008",
          text: "Lung Care and Sleep Centre (Santacruz)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000014",
          text: "Nirjara Multispecialty Clinic (Kandivali West)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000015",
          text: "Advanced arthritis and Rheumatology Center",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000017",
          text: "AMORAC (Mumbai)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000018",
          text: "ELIOS Hospital (Nagpur)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },

        {
          value: "CC000019",
          text: "PAIN CLINIC OF INDIA (Chembur)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000020",
          text: "Dr.Das’s Pain Care Clinic (Thane)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000021",
          text: "Shreshtha Arthritis and Rumetology Clinic (Vijayawada)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000022",
          text: "RheuGlow Clinic (Palava)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000023",
          text: "Gleneagles Hospital (Parel)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000024",
          text: "ELIOS Hospital (Nagpur)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },

        //Old values
        // {
        //   value: "CC000003",
        //   text: "Jivdaya Clinic (Ghatkopar)",
        //   disabled: false,
        //   hasOldPatients: false,
        //   next: "PREF-TREATING-LOC",
        // },
        // {
        //   value: "CC000004",
        //   text: "Bethany (Thane)",
        //   disabled: false,
        //   hasOldPatients: false,
        //   next: "PREF-TREATING-LOC",
        // },
        // {
        //   value: "CC000005",
        //   text: "Godrej (Vikhroli)",
        //   disabled: false,
        //   hasOldPatients: false,
        //   next: "PREF-TREATING-LOC",
        // },
        // {
        //   value: "CC000006",
        //   text: "Fortis (Mulund)",
        //   disabled: false,
        //   hasOldPatients: false,
        //   next: "PREF-TREATING-LOC",
        // },
        // {
        //   value: "CC000007",
        //   text: "Icon Hospital (Dombivali)",
        //   disabled: false,
        //   hasOldPatients: false,
        //   next: "PREF-TREATING-LOC",
        // },
      ],
      responseType: "singleChoice",
    },
    "PREF-TREATING-LOC": {
      question:
        "From which IC4 clinic would you prefer to receive the treatment?",
      choices: [
        {
          value: "CC000001",
          text: "Mumbai Arthritis Clinic (Bhandup)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000002",
          text: "Ajit Scanning Center (Kalyan)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000003",
          text: "ICON Hospital (Dombivli)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000004",
          text: "Shreyas Health Care Clinic (Badlapur)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000005",
          text: "Suchak Polyclinic & Hospital(Malad)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000006",
          text: "Bliss Clinic (Thane)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000009",
          text: "Spandan Clinic (Airoli)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000010",
          text: "AIMS (Thane)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },

        {
          value: "CC000011",
          text: "Sigma Hospital (Mulund West)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000012",
          text: "Good Health Clinics (Bhandup West)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000013",
          text: "Good Health Clinics (Bhandup East)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000008",
          text: "Lung Care and Sleep Centre (Santacruz)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },

        {
          value: "CC000000",
          text: "Online",
          disabled: true,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000014",
          text: "Nirjara Multispecialty Clinic (Kandivali West)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000015",
          text: "Advanced arthritis and Rheumatology Center",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000017",
          text: "AMORAC (Mumbai)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000018",
          text: "ELIOS Hospital (Nagpur)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000019",
          text: "PAIN CLINIC OF INDIA (Chembur)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000020",
          text: "Dr.Das’s Pain Care Clinic (Thane)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000021",
          text: "Shreshtha Arthritis and Rumetology Clinic (Vijayawada)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000022",
          text: "RheuGlow Clinic (Palava)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000023",
          text: "Gleneagles Hospital (Parel)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
        {
          value: "CC000024",
          text: "ELIOS Hospital (Nagpur)",
          disabled: false,
          hasOldPatients: false,
          next: "DOB",
        },
      ],
      responseType: "singleChoice",
    },
    PID: {
      question: "What is your current Patient ID?",
      descriptions: [
        "You will find it behind the front cover of your patient file. It will be below the barcode on the white sticker.",
        "If you are not able to find it, please take help of the receptionist.",
      ],
      responseType: "text",
      next: "DOB",
    },
    DOB: {
      question: "Thank you, <Patient Name>. What is your Age?",
      responseType: "object",
      next: "GENDER",
    },
    GENDER: {
      question: "What is your gender?",
      responseType: "text",
      next: "MOBILE",
    },
    MOBILE: {
      question: "What is your mobile number?",
      responseType: "text",
      next: "MOBILE-VERIFY",
    },
    "MOBILE-VERIFY": {
      question: "Verify your mobile number",
      responseType: "text",
      next: "EMAIL",
    },
    EMAIL: {
      question: "What is your email ID",
      responseType: "object",
      next: "RESIDENCE",
    },
    RESIDENCE: {
      question: "Where do you live?",
      responseType: "object",
      next: "CONGRATS",
    },
    CONGRATS: {
      next: "PASWD",
    },
    PASWD: {
      responseType: "object",
      next: "DONE",
    },
  },
};

export default questionnaire;
